import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateSmsDripSequence as CreateSmsDripSequenceMutation,
    CreateSmsDripSequenceVariables as CreateSmsDripSequenceMutationVariables,
    SmsDripSequenceCreateInput,
} from 'nutshell-graphql-types';

import CREATE_SMS_DRIP_SEQUENCE from '../mutations/create-sms-drip-sequence.graphql';

export function useCreateSmsDripSequence(): {
    createDripSequence: (arg1: SmsDripSequenceCreateInput) => Promise<any>;
    isCreating: boolean;
    error: string | null | undefined;
} {
    const [createDripSequence, {loading, error}] = useMutation<
        CreateSmsDripSequenceMutation,
        CreateSmsDripSequenceMutationVariables
    >(CREATE_SMS_DRIP_SEQUENCE);

    return {
        createDripSequence: (input: SmsDripSequenceCreateInput) =>
            createDripSequence({variables: {input}}),
        isCreating: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
